export default {
  TOKEN_KEY: process.env.REACT_APP_AUTH_CODE || 'searchstream-auth-token',
  API_ENDPOINT: 'https://calm-cliffs-26137.herokuapp.com/api'
};
